import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { RingLoader } from "react-spinners";
import ImageSize from "./ImageSize";

const Container = styled.div`
    /* Стили для контейнера */
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const StyledButton = styled.button`
    background-color: #48bb78;
    &:hover {
        background-color: #38a169;
    }
    color: white;
    font-size: 1.5em;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
`;

const StyledButtonDelete = styled.button`
    background-color: #f44336;
    &:hover {
        background-color: #e53935;
    }
    color: white;
    font-size: 1.5em;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
`;

const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
`;

const StyledMessage = styled.div`
    text-align: center;
    color: #48bb78;
    font-size: 28px;
    margin-bottom: 10px;
`;

const CanvasContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const isMobile = window.innerWidth <= 768;

const RemoveBackgroundImageViewer = (props) => {
    const {
        titleDownload,
        titleDownloadAll,
        titleCopy,
        titleCopied,
        titleDelete,
        titleReady,
        titleCancel,
        titleRemoveBackground,
        titleRemoveBackgroundAll,
        titleRemoveBackgroundAnotherImage,
        titleModel,
    } = props.attributes;

    const [showImage, setShowImage] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isProcessingFinished, setIsProcessingFinished] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [downloadFileUrls, setDownloadFileUrls] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [showViewer, setShowViewer] = useState(true);

    const [selectedModel, setSelectedModel] = useState("u2net");
    const modelOptions = [
        "isnet-anime",
        "isnet-general-use",
        /* "sam", */
        "silueta",
        "u2net",
        "u2net_cloth_seg",
        /* "u2net_custom", */
        "u2net_human_seg",
        "u2netp",
    ];

    const handleModelChange = (e) => {
        setSelectedModel(e.target.value);
    };

    const canvasRef = useRef(null);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth * 0.9,
        height: window.innerHeight,
    });

    const handleResize = () => {
        setWindowSize({
            width: window.innerWidth * 0.9,
            height: window.innerHeight,
        });
        drawImageProportional();
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const drawImageProportional = () => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");
        const image = new Image();
        image.src = props.imageUrl;

        const drawImage = () => {
            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;
            const imageWidth = image.width;
            const imageHeight = image.height;

            const maxImageSize = Math.min(canvasWidth, canvasHeight);
            const scaleFactor =
                maxImageSize / Math.max(imageWidth, imageHeight);

            const scaledWidth = imageWidth * scaleFactor;
            const scaledHeight = imageHeight * scaleFactor;

            const x = (canvasWidth - scaledWidth) / 2;
            const y = (canvasHeight - scaledHeight) / 2;

            ctx.clearRect(0, 0, canvasWidth, canvasHeight);
            ctx.drawImage(image, x, y, scaledWidth, scaledHeight);
        };

        if (image.complete) {
            drawImage();
        } else {
            image.onload = drawImage;
        }
    };

    useEffect(() => {
        drawImageProportional();
    }, [props.imageUrl, showImage, windowSize]);

    const handleRemoveBackground = async (e) => {
        e.preventDefault();

        setIsLoading(true);
        setShowImage(false);
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });
        const requestBody = {
            fileid: props.fileId,
            model: selectedModel,
        };

        try {
            const timestamp = Date.now();

            const response = await fetch(
                `/api/removeBackgroundImage?timestamp=${timestamp}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            if (!response.ok) {
                const responseData = await response.json();
                throw new Error(responseData.message);
            }

            const responseData = await response.json();
            setIsProcessingFinished(true);
            setDownloadUrl(responseData.url);
            setIsLoading(false);
            setIsDownloading(false);
            props.setShowUploader(false);
            document.body.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } catch (error) {
            setErrorMessage(error.message);
            setIsLoading(false);
            props.setShowUploader(false);
        }
    };

    const handleRemoveBackgroundAll = async (e) => {
        e.preventDefault();

        setIsLoading(true);
        setShowImage(false);
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });
        const requestBody = {
            fileid: props.fileId,
            model: selectedModel,
        };

        try {
            const timestamp = Date.now();

            const response = await fetch(
                `/api/removeBackgroundImageAll?timestamp=${timestamp}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            if (!response.ok) {
                const responseData = await response.json();
                throw new Error(responseData.message);
            }

            const responseData = await response.json();
            setIsProcessingFinished(true);
            setDownloadUrl(responseData.url);
            setDownloadFileUrls(responseData.fileUrls);
            setIsLoading(false);
            setIsDownloading(false);
            props.setShowUploader(false);
            document.body.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } catch (error) {
            setErrorMessage(error.message);
            setIsLoading(false);
            props.setShowUploader(false);
        }
    };

    const handleDownload = (e) => {
        e.stopPropagation();
        setIsDownloading(true);
        props.setShowUploader(false);
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const resetDownload = () => {
        setIsDownloading(false);
        setIsProcessingFinished(false);
        setDownloadUrl(null);
        setShowImage(true);
        props.setShowUploader(true);
    };

    const reloadPage = () => {
        setShowImage(true);
        location.reload();
    };

    const [copiedIndex, setCopiedIndex] = useState(null);

    const handleCopyToClipboard = (fileUrl, index) => {
        navigator.clipboard.writeText(fileUrl);
        setCopiedIndex(index);

        setTimeout(() => {
            setCopiedIndex(null);
        }, 5000);
    };

    const getFileName = (url) => {
        return url.substring(url.lastIndexOf("/") + 1);
    };

    return (
        <Container>
            {showImage && (
                <div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <CanvasContainer>
                            <canvas
                                width={windowSize.width * 0.5}
                                height={windowSize.height * 0.5}
                                ref={canvasRef}
                            />
                        </CanvasContainer>
                        <div
                            className="px-4 py-2"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <span
                                style={{
                                    marginRight: "10px",
                                    alignSelf: "center",
                                }}
                            >
                                {titleModel}
                            </span>
                            <select
                                className="px-4"
                                value={selectedModel}
                                onChange={handleModelChange}
                            >
                                {modelOptions.map((model, index) => (
                                    <option key={index} value={model}>
                                        {model}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div
                            className="px-4 py-2"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <ButtonContainer>
                                <StyledButton onClick={handleRemoveBackground}>
                                    {titleRemoveBackground}
                                </StyledButton>
                            </ButtonContainer>
                            <div className="px-4">
                                <ButtonContainer>
                                    <StyledButton
                                        onClick={handleRemoveBackgroundAll}
                                    >
                                        {titleRemoveBackgroundAll}
                                    </StyledButton>
                                </ButtonContainer>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {errorMessage && (
                <div>
                    <div className="px-4 py-2">
                        <div
                            className="w-full flex items-center bg-red-500 text-white text-sm font-bold px-4 py-3"
                            role="alert"
                        >
                            {errorMessage}
                        </div>
                    </div>
                    <div className="px-4 py-2">
                        <ButtonContainer>
                            <StyledButton onClick={reloadPage}>
                                {titleRemoveBackgroundAnotherImage}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                </div>
            )}
            {isLoading && (
                <LoaderContainer>
                    <RingLoader
                        color={"#123abc"}
                        loading={isLoading}
                        size={150}
                    />
                </LoaderContainer>
            )}
            {isProcessingFinished && !isDownloading && (
                <div>
                    <StyledMessage>{titleReady}</StyledMessage>
                    {downloadFileUrls && (
                        <ButtonContainer>
                            <div className="pt-2" style={{ display: "flex" }}>
                                <a
                                    href={downloadUrl}
                                    download={getFileName(downloadUrl)}
                                    onClick={handleDownload}
                                >
                                    <StyledButton>
                                        {titleDownloadAll}
                                    </StyledButton>
                                </a>
                                <a className="pl-2" onClick={handleDownload}>
                                    <StyledButtonDelete>
                                        {titleDelete}
                                    </StyledButtonDelete>
                                </a>
                            </div>
                        </ButtonContainer>
                    )}
                    {downloadFileUrls && (
                        <table className="w-full">
                            <thead className="hidden md:table-header-group">
                                <tr>
                                    <th className="text-left text-gray-800">
                                        URL
                                    </th>
                                    <th className="text-left text-gray-800">
                                        {titleDownload}
                                    </th>
                                    <th className="text-left text-gray-800">
                                        {titleCopy}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {downloadFileUrls.map((fileUrl, index) => (
                                    <React.Fragment key={index}>
                                        <tr
                                            key={index}
                                            className="flex flex-col md:table-row"
                                        >
                                            {!isMobile && (
                                                <>
                                                    <td className="md:border md:p-2">
                                                        <div
                                                            className="pt-2"
                                                            style={{
                                                                display: "flex",
                                                            }}
                                                        >
                                                            <img
                                                                src={`${fileUrl}?t=${new Date().getTime()}`}
                                                                alt="Viewer"
                                                                style={{
                                                                    width: "360px",
                                                                    objectFit:
                                                                        "contain",
                                                                }}
                                                            />
                                                        </div>
                                                        <div
                                                            className="pt-2"
                                                            style={{
                                                                display: "flex",
                                                            }}
                                                        >
                                                            <ImageSize
                                                                src={fileUrl}
                                                                attributes={
                                                                    props.attributes
                                                                }
                                                            />
                                                        </div>
                                                    </td>
                                                </>
                                            )}
                                            <td className="md:border p-2 w-full">
                                                <a
                                                    href={fileUrl}
                                                    download={getFileName(
                                                        fileUrl
                                                    )}
                                                    className="w-full break-all block"
                                                >
                                                    {fileUrl}
                                                </a>
                                            </td>
                                            {!isMobile && (
                                                <>
                                                    <td className="md:border md:p-2">
                                                        <a
                                                            href={fileUrl}
                                                            download={getFileName(
                                                                fileUrl
                                                            )}
                                                            className="bg-green-500 text-white px-3 py-2 rounded mr-2 focus:outline-none"
                                                        >
                                                            {titleDownload}
                                                        </a>
                                                    </td>
                                                    <td className="md:border md:p-2">
                                                        <button
                                                            className="bg-blue-500 text-white px-3 py-2 rounded focus:outline-none"
                                                            onClick={() =>
                                                                handleCopyToClipboard(
                                                                    fileUrl,
                                                                    index
                                                                )
                                                            }
                                                        >
                                                            {copiedIndex ===
                                                            index
                                                                ? titleCopied
                                                                : titleCopy}
                                                        </button>
                                                    </td>
                                                </>
                                            )}
                                        </tr>
                                        {isMobile && (
                                            <tr className="flex flex-col md:table-row">
                                                <td className="border p-2 flex items-center justify-around">
                                                    <div>
                                                        <a
                                                            href={fileUrl}
                                                            download={getFileName(
                                                                fileUrl
                                                            )}
                                                            className="bg-green-500 text-white px-3 py-2 rounded mr-2 focus:outline-none"
                                                        >
                                                            {titleDownload}
                                                        </a>
                                                    </div>
                                                    <div>
                                                        <button
                                                            onClick={() =>
                                                                navigator.clipboard.writeText(
                                                                    fileUrl
                                                                )
                                                            }
                                                            className="bg-red-500 text-white px-3 py-2 rounded focus:outline-none"
                                                        >
                                                            {titleCopy}
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    )}

                    <ButtonContainer>
                        {!downloadFileUrls && (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <img
                                    src={downloadUrl}
                                    alt="Viewer"
                                    style={{
                                        width: "360px",
                                        objectFit: "contain",
                                    }}
                                />
                                <div
                                    className="pt-2"
                                    style={{ display: "flex" }}
                                >
                                    <ImageSize
                                        src={downloadUrl}
                                        attributes={props.attributes}
                                    />
                                </div>
                                <div
                                    className="pt-2"
                                    style={{ display: "flex" }}
                                >
                                    <a
                                        href={downloadUrl}
                                        download={getFileName(downloadUrl)}
                                        onClick={handleDownload}
                                    >
                                        <StyledButton>
                                            {titleDownload}
                                        </StyledButton>
                                    </a>
                                    <a
                                        className="pl-2"
                                        onClick={handleDownload}
                                    >
                                        <StyledButtonDelete>
                                            {titleDelete}
                                        </StyledButtonDelete>
                                    </a>
                                </div>
                            </div>
                        )}
                    </ButtonContainer>
                </div>
            )}
            {isDownloading && (
                <div>
                    <ButtonContainer>
                        <StyledButton onClick={resetDownload}>
                            {titleRemoveBackgroundAnotherImage}
                        </StyledButton>
                    </ButtonContainer>
                </div>
            )}
        </Container>
    );
};

export default RemoveBackgroundImageViewer;
